if (!customElements.get('platonline-seals')) {
  customElements.define('platonline-seals', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.closest('form');
      const place = () => {
        const buy = form?.querySelector('button[name="add"],button.add-to-cart');
        if (buy && buy.previousElementSibling !== this) buy.before(this);
      };
      queueMicrotask(place);
      this.observer = new MutationObserver(place);
      if (form) this.observer.observe(form, { childList: true, subtree: true });
      for (const type of ['input', 'change']) this.addEventListener(type, event => event.stopPropagation());
      this.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target.matches('[data-seal-quantity]')) {
          event.preventDefault();
          event.stopPropagation();
          event.target.closest('[data-seal-row]').querySelector('[data-seal-add]').click();
        }
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-seal-add]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        this.add(button);
      });
    }
    disconnectedCallback() {
      queueMicrotask(() => { if (!this.isConnected) this.observer?.disconnect(); });
    }
    async add(button) {
      if (this.busy || button.disabled) return;
      const input = button.closest('[data-seal-row]').querySelector('[data-seal-quantity]');
      const status = this.querySelector('[role="status"]');
      const value = input.value.trim();
      const quantity = Number(value);
      status.dataset.error = 'false';
      if (!/^\d+$/.test(value) || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 999) {
        status.dataset.error = 'true';
        status.textContent = this.dataset.invalid;
        input.focus();
        return;
      }
      this.busy = true;
      const buttons = [...this.querySelectorAll('[data-seal-add]:not(:disabled)')];
      buttons.forEach(item => item.disabled = true);
      this.setAttribute('aria-busy', 'true');
      status.textContent = this.dataset.adding;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity }] })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
        status.textContent = this.dataset.success;
        try {
          const cartResponse = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store' });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('.cartCountSelector').forEach(el => el.textContent = cart.item_count);
            if (window.Shopify?.formatMoney && window.theme?.moneyFormat) {
              document.querySelectorAll('.cartTotalSelector').forEach(el => el.innerHTML = window.Shopify.formatMoney(cart.total_price, window.theme.moneyFormat));
            }
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart }, bubbles: true }));
            if (typeof window.CartDrop === 'function') window.CartDrop(true);
          }
        } catch (_) {}
      } catch (error) {
        status.dataset.error = 'true';
        status.textContent = error instanceof TypeError ? this.dataset.error : error.message || this.dataset.error;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        buttons.forEach(item => item.disabled = false);
      }
    }
  });
}
